
import moment from "moment";
import axiosPost from "./axiosPost";

export const merchantServicioUsuarioGet = async ({
  servicioCod,
  usuarioId = null,
  rolCod = null,
  rolTipo = '',
}, credentials) => {
  const body = {
    service: "MerchantServicioUsuarioGet",
    params: {
      merchantId: credentials.merchantId,
      servicioCod,
      merchantServicioUsuarioFecha: moment().format("YYYY-MM-DD"),
      usuarioId,
      rolCod,
      rolTipo,
    },
  };

  return await axiosPost(body, credentials);
};